module.exports = __webpack_public_path__ + "img/mimas.9882bf7d.png";